import { configWithWebToken } from "./config";
import {
  IReservationRequestPayload,
  IReservationRequestResponse,
  IResendCodePayload,
  IVerifyReservationPayload,
  IReservationCancelCodeResponse,
  IReservationCancelWithCodePayload,
} from "../models/IReservationRequest";
import { IReservationCheckResponse } from "../models/IReservationCheck";

export const createReservationRequest = (payload: IReservationRequestPayload) =>
  configWithWebToken.post<IReservationRequestResponse>("ReservationRequest", payload);

export const verifyReservationCode = (payload: IVerifyReservationPayload) =>
  configWithWebToken.post("ReservationRequest/verify", payload);

export const resendReservationCode = (payload: IResendCodePayload) =>
  configWithWebToken.post<Partial<IReservationRequestResponse>>(
    "ReservationRequest/resend-code",
    payload
  );

export const checkReservation = (id: string) =>
  configWithWebToken.get<IReservationCheckResponse>(`Reservation/${id}/check`);

export const requestReservationCancelCode = (reservationId: string, captchaToken: string) =>
  configWithWebToken.post<IReservationCancelCodeResponse>(
    `ReservationRequest/${reservationId}/cancel-code`,
    { captchaToken }
  );

export const cancelReservationWithCode = (
  reservationId: string,
  payload: IReservationCancelWithCodePayload
) => configWithWebToken.post(`ReservationRequest/${reservationId}/cancel-with-code`, payload);
